(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["laravel-vue-pagination"] = factory();
	else
		root["laravel-vue-pagination"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 